export const BASE_USERS = '/v1/users';
export const BASE_USERS_V2 = '/v2/users';

export const USER_BY_ID = `${BASE_USERS}/:id`;
export const ROLES = `${BASE_USERS}/roles`;
export const ROLES_V2 = `${BASE_USERS_V2}/roles`;

export const EMAIL_TYPES = `${BASE_USERS}/emailTypes`;

export const BASE_USERS_PARTNERS = '/v1/users/partners';
export const BASE_USERS_PARTNERS_V2 = '/v1/users/V2/partners';

export const PARTNER_ADMIN_ACCESS = `${BASE_USERS_PARTNERS}/admin-access`;
export const UNLINK_PARTNERS_V2 = `${BASE_USERS_PARTNERS_V2}/unlink`;
